import { SurveyV2 } from '@act/shared/data-transfer-objects';
import { ControlledSelect } from '@act/storybook';
import { Control } from 'react-hook-form';

export interface SelectInputProps {
  control: Control<{ [key: string]: string }>;
  name: string;
  options: SurveyV2.CreateOptionJSONDto[];
  isMultiple: boolean;
  isRequired: boolean;
  togglePrompt: (prompt: SurveyV2.CreatePromptJSONDto) => void;
}

const SelectInput = ({
  control,
  name,
  options,
  isMultiple,
  isRequired,
  togglePrompt,
}: SelectInputProps) => {
  if (isMultiple) {
    throw new Error('Multiple select is not supported');
  }

  const formattedOptions = options.map(options => {
    return {
      label: options.text,
      value: `${options.sortOrder}`,
      callback: () => togglePrompt(options.prompt),
    };
  });
  // TODO: Enable multi-select
  return (
    <ControlledSelect
      name={name}
      label={''}
      control={control}
      options={formattedOptions}
      required={isRequired}
      fullWidth
    />
  );
};

export default SelectInput;
